import type { CatalogProduct } from '../types'
import { Artwork } from './Artwork'
import { Icon } from './Icon'

type ProductCardProps = {
  product: CatalogProduct
  onSelect: (slug: string) => void
  onAdd: (variantId: string) => void
}

export function ProductCard({ product, onSelect, onAdd }: ProductCardProps) {
  return (
    <article className="product-card">
      <button
        aria-label={product.name + ' の詳細を見る'}
        className="product-card__visual"
        onClick={() => onSelect(product.slug)}
        type="button"
      >
        <Artwork product={product} />
        <span className="product-card__heart"><Icon name="heart" size={21} /></span>
      </button>
      <button className="product-card__copy" onClick={() => onSelect(product.slug)} type="button">
        <span className="product-card__name">{product.name}</span>
        <span className="price">￥{product.price.toLocaleString('ja-JP')}</span>
      </button>
      <button className="product-card__quick-add" onClick={() => onAdd(product.variantId)} type="button">
        カートに入れる
      </button>
    </article>
  )
}

